const menuPages: { [key: string]: string } = {
  "dashboard": "/dashboard",
  "tags": "/dashboard-configuration/tags",
  "alarms": "/alarms",
  "tickets": "/tickets",
  "data_sources": "/data-sources",
  "users": "/users",
  "logs": "/logs",
};

export default menuPages;